<template>
  <div >
      <div class="container-box-1" style="color: #383838; text-align: left; background-color: white; opacity: 0.9;">
          
          <div style="width: 100%; text-align: center;">
              <img 
                src="http://donquijote.b-cdn.net/eventsonline/hot-offer-1.png" 
                style="position: relative; top: -62px; margin: 0 auto;">
          </div>
          
          <div v-if="$store.state.budget.financial_configuration.date_range_discount.length>0" class="row" style="text-align: center; padding: 50px; top: -80px; position: relative; font-size: 15px; letter-spacing: 1px; line-height: 30px; font-weight: bold;">
              <span v-html="$store.state.budget.financial_configuration.offer_page_header"></span>
          </div>
          <div v-else class="row" style="text-align: center; padding: 50px; top: -80px; position: relative; font-size: 25px; letter-spacing: 1px; line-height: 30px; font-weight: bold;">
              Proximamente veras fechas con promociones increibles!!
          </div>
          
          <div class="row" style=" top: -110px; position: relative; ">
            <OfferGrid :list="$store.state.budget.financial_configuration.date_range_discount"></OfferGrid>              
          </div>      
          
      </div>  
      <br><br><br>
  </div>  
</template>

<script>
import OfferGrid from './OfferGrid.vue'
export default {
    components: {
        OfferGrid
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Offers/Index.vue